var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-slide-y-reverse-transition',[(_vm.notificationToShow && !_vm.switching.status)?_c('notification',{attrs:{"notification-to-show":_vm.notificationToShow},on:{"end-notification":_vm.removeNotification}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }